import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import isString from "lodash/isString";

const TabSwitcher = ({ value, onChange, tabs, sx }) => {
  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="basic tabs example"
      sx={sx}
    >
      {tabs?.map((tab) => {
        const tab_label = isString(tab) ? tab : tab?.label;
        const tab_value = isString(tab) ? tab : tab?.value;

        return <Tab key={tab_value} label={tab_label} value={tab_value} />;
      })}
    </Tabs>
  );
};

export default TabSwitcher;
